import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fontSerifCurrent.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/BDMegalona-Regular.woff2%22,%22style%22:%22normal%22,%22weight%22:%22400%22},{%22path%22:%22../../public/fonts/BDMegalona-Medium.woff2%22,%22style%22:%22normal%22,%22weight%22:%22500%22},{%22path%22:%22../../public/fonts/BDMegalona-SemiBold.woff2%22,%22style%22:%22normal%22,%22weight%22:%22600%22}],%22variable%22:%22--font-serif%22}],%22variableName%22:%22megalona%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'megalona', 'megalona Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
